import LogoClinical from '@assets/logo-clinical.png';
import LogoPlus from '@assets/logo-plus.png';
import SejaPlus from '@assets/seja-plus.png';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@components/ui/sidebar';
import { pages } from '@constants/pages';
import { useAuth } from '@contexts/auth';
import {
  BriefcaseMedical,
  Calculator,
  FileText,
  Heart,
  Info,
  LogOut,
  MessageCircleMore,
  PanelRightClose,
  Pill,
  ShieldAlert,
  Shuffle,
  UserRound,
} from 'lucide-react';
import { Link } from 'react-router';

import { Button } from './ui/button';
import { useSidebar } from './ui/sidebar/useSidebar';

export function AppSidebar() {
  const { rightSidebar } = useSidebar();
  const { onLogout, user } = useAuth();

  const handleLogout = () => {
    onLogout();
    rightSidebar.setOpenMobile(false);
    rightSidebar.setOpen(false);
  };

  function handleClose() {
    rightSidebar.setOpenMobile(false);
    rightSidebar.setOpen(false);
  }

  return (
    <Sidebar side="right">
      <SidebarHeader className="relative flex-col items-start gap-0 px-3">
        <Button
          className="text-background cursor-pointer"
          onClick={rightSidebar.toggleSidebar}
          size="icon"
          title="Fechar"
          variant="ghost">
          <PanelRightClose className="size-7" strokeWidth={1.5} />
        </Button>
        <div className="flex w-full flex-col items-center gap-2">
          <Link onClick={handleClose} title="Início" to={pages.home}>
            <img
              alt="GPMED logo"
              className="w-40"
              src={user?.accessGranted ? LogoPlus : LogoClinical}
            />
          </Link>
          {!user?.accessGranted && (
            <Link onClick={handleClose} to={pages.payment}>
              <img
                alt="Plus logo"
                className="w-28"
                src={SejaPlus}
                title="Seja plus"
              />
            </Link>
          )}
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    title="Início"
                    to={pages.home}>
                    <BriefcaseMedical strokeWidth={1.5} />
                    Início
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    title="Anotações"
                    to={pages.notes.list}>
                    <FileText strokeWidth={1.5} />
                    Anotações
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    title="Calculadoras"
                    to={pages.calculators.list}>
                    <Calculator strokeWidth={1.5} />
                    Calculadoras
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    title="Medicamentos"
                    to={pages.medicines.list}>
                    <Pill strokeWidth={1.5} />
                    Medicamentos
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    title="Medicamentos"
                    to={pages.drugInteraction}>
                    <Shuffle strokeWidth={1.5} />
                    Interações medicamentosas
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    title="Favoritos"
                    to={pages.favorites}>
                    <Heart strokeWidth={1.5} />
                    Favoritos
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    title="Favoritos"
                    to={pages.suggestTopic}>
                    <MessageCircleMore strokeWidth={1.5} />
                    Sugerir um tema
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    title="Perfil"
                    to={pages.user.profile}>
                    <UserRound strokeWidth={1.5} />
                    Perfil
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg"
                  title="Termos e condições de uso">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    target="_blank"
                    to={pages.terms}>
                    <Info strokeWidth={1.5} />
                    Termos e condições de uso
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  className="hover:text-secondary active:text-secondary hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  size="lg">
                  <Link
                    className="text-background"
                    onClick={handleClose}
                    target="_blank"
                    title="Política de privacidade"
                    to={pages.privacyPolicies}>
                    <ShieldAlert strokeWidth={1.5} />
                    Política de privacidade
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  className="text-background hover:text-secondary active:text-secondary cursor-pointer hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap [&>svg]:size-7"
                  onClick={handleLogout}
                  size="lg">
                  <LogOut strokeWidth={1.5} />
                  Sair
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        <div className="flex flex-row justify-center gap-4 lg:gap-6">
          <a
            href="https://www.instagram.com/oguiadeprescricao/"
            target="_blank"
            title="Instagram">
            <img
              alt="Instagram logo"
              height="26"
              src="https://cdn.simpleicons.org/instagram/ffffff"
              width="26"
            />
          </a>
          <a
            href="https://www.facebook.com/oguiadeprescricao?locale=pt_BR"
            target="_blank"
            title="Facebook">
            <img
              alt="Facebook logo"
              height="26"
              src="https://cdn.simpleicons.org/facebook/ffffff"
              width="26"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=br.com.gpmed.app&hl=pt_BR"
            target="_blank"
            title="Google Play">
            <img
              alt="Google play logo"
              height="26"
              src="https://cdn.simpleicons.org/googleplay/ffffff"
              width="26"
            />
          </a>
          <a
            href="https://apps.apple.com/br/app/gpmed/id6476676703"
            target="_blank"
            title="App Store">
            <img
              alt="App store logo"
              height="26"
              src="https://cdn.simpleicons.org/appstore/ffffff"
              width="26"
            />
          </a>
        </div>
      </SidebarFooter>
    </Sidebar>
  );
}
